export const SET_CATEGORY = "SET_CATEGORY";